import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import TrialOutreachPill from '../../trial-outreach/components/TrialOutreachPill';
import { CATEGORY_OPTIONS, labelOf, instagramProfileLink } from '../prospectOptions';

/**
 * FollowerRow - Um perfil da lista de seguidores, com a caixa para importar.
 * @param {Object} props
 * @param {Object} props.item saída de readFollowersFile
 * @param {boolean} props.checked
 * @param {Function} props.onToggle
 */
function FollowerRow({ item, checked, onToggle }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.75, px: 0.5, borderBottom: '1px solid #E8ECF0' }}>
      <Checkbox size="small" checked={checked} onChange={() => onToggle(item.username)} sx={{ mt: -0.5 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Link href={instagramProfileLink(item.username)} target="_blank" rel="noopener" variant="body2" underline="hover" sx={{ fontWeight: 600 }}>
            @{item.username}
          </Link>
          {item.name && <Typography variant="body2" color="text.secondary">{item.name}</Typography>}
          {item.category && <TrialOutreachPill tone="blue" label={labelOf(CATEGORY_OPTIONS, item.category)} />}
        </Box>
        {item.bio && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }} noWrap>{item.bio}</Typography>
        )}
      </Box>
    </Box>
  );
}

export default FollowerRow;
